module.exports = __webpack_public_path__ + "assets/img/Logo-UIA.ac73108a.png";